/**
 * @fileoverview aside に表示される広告バナー用コンポーネント
 */
<script lang="ts">
import { defineComponent, computed } from 'vue'
import { documentPath } from '@/generated/railsRoutes'
import { pathWithQueryParams } from '@/utilities/path'
import { sendGtmEvent } from '@/utilities/googleTagManager'
import { useClientStore } from '@/stores/client'
import banner01 from '@/images/banner/banner-ad-smarthr_01.png'
import banner02 from '@/images/banner/banner-featured-smarthr_02.jpg'

export default defineComponent({
  name: 'AsideAdBanner',

  setup() {
    // store
    const clientStore = useClientStore()

    interface Banner {
      image: string,
      alt: string,
      to: string,
      params?: () => QueryParameter[],
      target?: '_blank' | '_self' | '_parent' | '_top',
      rel?: string,
      gtmEvent?: {
        name: string,
        value?: string | number | boolean,
      },
    }
    const BANNERS: Array<Banner> = [
      {
        image: banner01,
        alt: 'SmartHR - 労務管理からタレントマネジメントまで',
        to: 'https://smarthr.jp/',
        params: () => [
          {
            name: 'utm_source',
            value: 'bizhint',
          },
          {
            name: 'utm_medium',
            value: 'cpc',
          },
          {
            name: 'utm_campaign',
            value: 'bizhint-cpc',
          },
        ],
        rel: 'noopener noreferrer',
        gtmEvent: {
          name: 'rectangle01',
        }
      },
      {
        image: banner02,
        alt: '社労士監修！中間管理職が知っておきたい労務知識',
        to: documentPath({ id: 601704 }),
        params: () => [clientStore.trackingCodeParam('rc_rectangle02')],
        gtmEvent: {
          name: 'rectangle02',
        }
      }
    ]

    let isClicked = false
    // trackingCodePrefix の更新時に表示バナーが切り替わらないよう、選択結果を固定する
    const renderIndex = Math.floor(Math.random() * BANNERS.length)

    /**
     * 表示用バナー
     * @description 設定されてるバナー配列からランダムで一つ表示される。
     */
    const renderBanner = computed(() => {
      const banner = BANNERS[renderIndex]
      const path = pathWithQueryParams(banner.to, banner.params?.() ?? [])
      const target = banner.target || '_blank'
      const rel = banner.rel || undefined

      const pageCategory = /\/(.+?)\//.exec(location.pathname)
      const eventValue = pageCategory ? pageCategory[1] : 'home'
      const gtmEvent = {
        name: banner.gtmEvent?.name,
        value: banner.gtmEvent?.value || eventValue,
      }

      return {
        image: banner.image,
        alt: banner.alt,
        path,
        target,
        rel,
        gtmEvent,
      }
    })

    const onClick = () => {
      if (!renderBanner.value || !renderBanner.value.gtmEvent?.name) return
      if (isClicked) return

      sendGtmEvent(renderBanner.value.gtmEvent.name, renderBanner.value.gtmEvent.value)

      isClicked = true
    }

    return {
      // routes
      documentPath,

      // computed
      renderBanner,

      // methods
      onClick,
    }
  },
})
</script>

<template>
  <section class="section">
    <p class="p">
      <a
        class="a"
        :href="renderBanner.path"
        :target="renderBanner.target"
        :rel="renderBanner.rel"
        @click="onClick">
        <img
          class="img"
          :src="renderBanner.image"
          loading="lazy"
          :alt="renderBanner.alt">
      </a>
    </p>
  </section>
</template>
